import { useState } from "react"

import { Button, EditFieldList } from "web/components"
import { Input } from "web/components/Form/Controls"

import { useFields, useFormSectionFields } from "web/hooks/data"
import { useModals, useDialogModal, Dialogs } from "web/hooks/modals"

function ShowSection({ section, respond, subjectType = null }) {
  const [label, setLabel] = useState({ value: section.label })

  const confirmDeleteModal = useDialogModal(Dialogs.ConfirmDelete("section"))

  const sectionFields = useFormSectionFields(section.id)

  const allFields = useFields({
    subjectType: subjectType || section.subject_type,
    topicId: section.topic_id,
  })

  async function handleSaveLayout() {
    await section.update({ label: label.value })
    respond()
  }

  async function handleDeleteLayout() {
    const dialogResult = await confirmDeleteModal()
    if (dialogResult && dialogResult.response) {
      await section.destroy()
      respond()
    }
  }

  return (
    <div className="h-full">
      <div className="modal-content-above-commands">
        <div className="grid gap-y-5">
          <Input label="Name" value={label} onChange={setLabel} />
          <EditFieldList fields={sectionFields} allFields={allFields} />
        </div>
      </div>
      <div className="modal-commands">
        <div className="left-buttons">
          <Button onClick={handleSaveLayout}>Save</Button>
          <Button variant="tertiary_default" onClick={respond}>
            Close
          </Button>
        </div>
        <div className="right-buttons">
          <Button variant="primary_danger" onClick={handleDeleteLayout}>
            Delete
          </Button>
        </div>
      </div>
    </div>
  )
}

export default function useShowSectionModal() {
  const { showModal } = useModals()

  return async function (section, subjectType) {
    return await showModal({
      title: "View/Edit Section",
      fullScreen: false,
      heightPixels: 800,
      widthPixels: 800,
      component: ({ respond }) => (
        <ShowSection
          section={section}
          subjectType={subjectType}
          respond={respond}
        />
      ),
    })
  }
}
